type MetricProps = { name: string; value: string }

const Metric = ({ name, value }: MetricProps) => (
  <div className='col-6 col-sm-5'>
    <h3 className='mc-text-color--primary mc-text-h8 mc-text--uppercase'>
      {name}
    </h3>
    <span className='mc-text-large d-block mc-mt-2'>{value}</span>
  </div>
)

export default Metric
